module.exports = __webpack_public_path__ + "img/information.22738b91.svg";